<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  export let onAccept = null;
  export let companyName: string;
  let showModal: boolean = true;

  function onAcceptWrapper() {
    showModal = false;
    if (onAccept) {
      onAccept();
    } else {
      let app = "retailer";
      if (window["C"]["APP_NAME"] == "distributor") {
        app = "distributor";
      }
      HttpPromise({
        method: "PUT",
        url: `/api/${app}/user`,
        data: {
          user: {
            accepted_terms: true,
          },
        },
      }).then(function success(res) {
        window["$rootScope"].user.accepted_terms_at = true;
      });
    }
  }
</script>

<FizzStyles>
  <Modal
    bind:show={showModal}
    closeOnBackgroundClick={false}
    fizzModal={true}
    center={true}
    tiny={true}
  >
    <section style="padding:24px;">
      <h4 class="fizz-heading-4 fizz-stack-16">Updates</h4>

      <p class="fizz-stack-32 iefixwidth">
        We have updated our general
        <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
        and published a new
        <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>. You must
        click below to continue using {companyName}.
      </p>

      <footer class="fizz-flex-row fizz-justify-end" style="display:flex;">
        <button class="fizz-button-secondary cursor-pointer" on:click={onAcceptWrapper}
          >I Accept</button
        >
      </footer>
    </section>
  </Modal>
</FizzStyles>
